// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1872":"02bb9df4","5434":"5a319666","5547":"5a319666","8001":"5a319666","8741":"5a319666"}[chunkId] + ".chunk.css";
};